<script>
  import ActionButton from "./ActionButton.svelte";
  import {
    GameStateStore,
    Hearts,
    PlayerId,
    PlayersStore,
    SetupStore,
    RogueCounter,
    SelectedActions,
  } from "../stores/gameStore";

  export let stacked;

  $: color = "#" + $PlayersStore[$PlayerId]?.color;
  $: isActive = ($GameStateStore?.name === "actionSelection") || ($GameStateStore?.name === "potionSelectNewAction");
  $: rogueCounter = $RogueCounter;
  $: selectedAction = $SelectedActions.find(player => player.playerId === $PlayerId)?.action || false;

  const clickButton = () => {};

  const types = [
    "ACTION_KING",
    "ACTION_HEAL",
    "ACTION_FIGHT_01",
    "ACTION_GUARD",
    "ACTION_FIGHT_02",
    "ACTION_CRAFT",
    "ACTION_FIGHT_03",
  ];

  const typesRogue = [
    "ACTION_ROGUE_04",
    "ACTION_ROGUE_02",
    "EMPTY",
    "ACTION_ROGUE_01",
    "EMPTY",
    "EMPTY",
    "ACTION_ROGUE_03",
  ];

  const fightActions = [
    "ACTION_KING",
    "ACTION_FIGHT_01",
    "ACTION_FIGHT_02",
    "ACTION_FIGHT_03",
    "ACTION_ROGUE_03",
    "ACTION_ROGUE_04",
  ];

  $: hearts = $Hearts?.[$PlayerId] || 0;
  $: playerBoards = $SetupStore?.playerboards;
  $: boardId = playerBoards?.[$PlayerId]?.board_ID;

  const textSelectAnAction = _('Select an action');
</script>


<div
class="wrapper"
class:stacked={stacked}
>
  <div style:font-weight={600}>{textSelectAnAction}</div>
  <div class="buttons">
    {#each types as type}
      <div
      class:notRecommended={hearts === 0 && fightActions.includes(type)}
      class:selected={type === selectedAction}
       >
        <ActionButton
          width={50}
          onclick={isActive
            ? () => {
                window.GAME.bgaPerformAction("selectAction", {
                  actionId: type,
                  playerId: $PlayerId,
                },
                { checkAction: false });
              }
            : undefined}
          {type}
        />
      </div>
    {/each}
  </div>
  <!-- Rogue Actions -->
{#if boardId === "ROGUE_SPEC"}
  <div class="buttons">
    {#each typesRogue as type}
      {#if type === "EMPTY"}
        <div class="empty-space">
        </div>
      {:else}
        <div
        class:disabled={!rogueCounter[type]}
        class:notRecommended={hearts === 0 && fightActions.includes(type)}
        class:selected={type === selectedAction}
        >
          <ActionButton
          width={50}
          onclick={rogueCounter[type] && isActive
            ? () => {
                window.GAME.bgaPerformAction("selectAction", {
                  actionId: type,
                  playerId: $PlayerId,
                },
                { checkAction: false });
              }
            : undefined}
          {type}
          />
        </div>
      {/if}
    {/each}
  </div>
{/if}
</div>


<style>
  .wrapper {
    display: flex;
    gap: 0.25rem;
    flex-direction: column;
  }

  .wrapper.stacked {
    align-items: center;
  }

  .buttons {
    display: flex;
    gap: 0.5rem;
  }

  .disabled {
    filter: brightness(.75);
    opacity: 0.5;
    cursor: not-allowed;     /* Change cursor to indicate it's not clickable */
    pointer-events: none;    /* Prevent clicking */
  }

  .notRecommended {
    filter: saturate(300%) hue-rotate(310deg) brightness(0.6);
  }

  .selected {
    border-radius: 30px;
    outline: 3px solid white;
    outline-offset: 2px;
  }
  
  .empty-space {
    width: 50px; /* Match the width of the ActionButton */
    height: 50px; /* Optional: Match the height if ActionButton has a defined height */
    flex-grow: 0; /* Prevents the empty space from growing */
  }
</style>
